import {
  memo,
  useCallback,
} from 'react';
import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

import type {
  HeaderDropdownOption,
} from './types';

export const StyledOption = styled.div(({
  theme: {
    colors,
    fonts,
    indents,
  },
}) => ({
  ...fonts.DEFAULT,
  display: 'block',
  width: '100%',
  boxSizing: 'border-box',
  margin: 0,
  paddingTop: 4,
  paddingBottom: 4,
  paddingLeft: indents.INDENT_2,
  paddingRight: indents.INDENT_2,
  backgroundColor: 'transparent',
  color: colors.TEXT_PRIMARY,
  cursor: 'pointer',
  outline: 'none',
  border: 'none',
  whiteSpace: 'nowrap',
  textAlign: 'left',

  ':hover': {
    backgroundColor: colors.ACTION_BACKGROUND,
    color: colors.TEXT_PRIMARY,
  },

  ':active': {
    backgroundColor: colors.ACTION_BACKGROUND,
    color: colors.TEXT_PRIMARY,
  },
}));

export type DropdownOptionProps = {
  option: HeaderDropdownOption;
  closeDropdown: () => void;
};

function DropdownOptionInner({
  option: {
    component,
    componentProps,
    label,
    onClick,
  },

  closeDropdown,
}: DropdownOptionProps): ReactElement {
  const onOptionClick = useCallback(() => {
    if (onClick) {
      onClick();
    }

    closeDropdown();
  }, [closeDropdown, onClick]);

  return (
    <StyledOption
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      as={component || 'div'}
      {...componentProps}
      onClick={onOptionClick}
    >
      {label}
    </StyledOption>
  );
}

export const DropdownOption = memo(DropdownOptionInner);
